import axios from 'axios';
// import Vue from 'vue';
import dayjs from 'dayjs';
import { fetchAuditAndSignData, auditPopRecord } from './fundApi';

// const CACHE_INFO = 'fund-business-qualified-investors-trace';

function getCommonParams() {
  return {
    CToken: window?.highEndInfo?.ctoken || '',
    UserId: window?.highEndInfo?.uid || '',
    Version: window?.highEndInfo?.appv || '6.7.0',
    CustomerNo: window?.highEndInfo?.uid || '',
    UToken: window?.highEndInfo?.utoken || '',
    AppType: window?.highEndInfo?.app || 'ttjj',
    MobileKey: window?.highEndInfo?.deviceid || '1234567.py.service',
    ServerVersion: window?.highEndInfo?.serverversion || '6.7.0',
    BType: '1',
    PhoneType: window?.highEndInfo?.plat || '1',
  };
}

function getCommonHeaders() {
  return {
    'Content-Type': 'application/json',
  };
}

/**
 * 异步获取是否为合格投资者
 */
const asyncIsAudit = async () => {
  const res = await fetchAuditAndSignData();
  if (res.Success && res.Data.auditResult) {
    return [2, 5, 6, 7].indexOf(Number(res.Data.auditResult)) > -1;
  }
  return false;
};

/**
 * 异步获取弹框标记
 */
const asyncIsNeedPop = async () => {
  // const cache = window?.highEndInfo?.investorTrace || '';
  // Vue.prototype.$feedback.showModal({
  //   title: '请求接口成功',
  //   content: `缓存时间: ${JSON.stringify(window?.highEndInfo?.investorTrace || '')}\n
  //   当前时间: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}\n
  //   是否过期：${dayjs(cache).isBefore(dayjs().subtract(10, 'minute'))}`,
  // });
  // if (cache && !dayjs(cache).isBefore(dayjs().subtract(10, 'minute'))) {
  //   return false;
  // }
  const commonParams = getCommonParams();
  if (!commonParams.UserId) {
    return false;
  }
  const requestData = { ...commonParams, contentversion: 'APP-1' };
  const zone = window?.highEndInfo?.zone || '';
  let zoneStr = zone;
  if (zone === '1') {
    zoneStr = '';
  }

  try {
    const res = await axios.post(
      `https://tradeapilvs${zoneStr}.1234567.com.cn/User/Account/GetCustomerAuditInfo`,
      requestData,
      { headers: getCommonHeaders() },
    );
    const result = res.data;
    // Vue.prototype.$feedback.showModal({
    //   title: '请求接口成功',
    //   content: `isNeedAuditPop: ${result?.Data?.IsNeedAuditPop}\n
    //  auditState; ${result?.Data?.AuditStatus?.AuditState}`,
    // });
    // 返回响应数据

    if (result.Success && result.Data) {
      const isNeedAuditPop = result?.Data?.IsNeedAuditPop;
      const auditState = result?.Data?.AuditStatus?.AuditState;
      console.log(isNeedAuditPop, auditState);
      const isAudit = [2, 5, 6, 7].indexOf(auditState - 0) > -1;
      console.log('是否真合格投资者', isAudit, isNeedAuditPop);

      if (!isNeedAuditPop) {
        // 有留痕 设置缓存 返回false
        const webPlatf = multi.$system.webPlatform;
        if (webPlatf === 'wxmp') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.postMessage({
            data: {
              data: {
                type: 'setCache',
                investorTrace: dayjs().format('YYYY-MM-DD HH:mm:ss'),
              },
            },
          });
        }
        return false;
      }
      if (!isAudit) {
        // 未留痕且是不是合格投资者的情况，需要弹框
        return true;
      }
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp') {
        // eslint-disable-next-line no-undef
        wx.miniProgram.postMessage({
          data: {
            data: {
              type: 'setCache',
              investorTrace: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            },
          },
        });
      }
      return false;
    }
  } catch (error) {
    console.error('请求失败', error);
    return false;
  }
  return false;
};

/**
 * 异步留痕
 */
const asyncSetAuditPopRecord = async () => {
  const result = await auditPopRecord();
  if (result.Success) {
    const webPlatf = multi.$system.webPlatform;
    if (webPlatf === 'wxmp') {
      // eslint-disable-next-line no-undef
      wx.miniProgram.postMessage({
        data: {
          data: {
            type: 'setCache',
            investorTrace: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          },
        },
      });
    }
    // multi.$storage.setStorage(CACHE_INFO, true, { expire: 60 * 60 * 24 * 30 });
  }
};

export { asyncIsNeedPop, asyncSetAuditPopRecord, asyncIsAudit };
